import { render } from "./PaymentsEdit.vue?vue&type=template&id=8c6735a6"
import script from "./PaymentsEdit.vue?vue&type=script&lang=js"
export * from "./PaymentsEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__